import React from "react";
import { FormSent } from "./FormSent";
import { FormError } from "./FormError";

export default function FormHandler({ error, text, sent }) {
  return sent ? <FormSent thankYou={text} /> : <FormError error={error} />;
}
